import { LottieSvg } from 'lottie-react'

import { cn } from '@/lib/cn'

/** Same Lottie used by android-consumer (`loading_new.json`) for the full-screen loader. */
const LOADING_GLOBE_SRC = '/assets/lottie/loading-globe.json'

interface LoadingGlobeProps {
  className?: string
  /** Pixel size. The Android loading dialog uses 100dp. */
  size?: number
}

/** Globe / earth Lottie loader for full-screen and page-level pending states. */
export function LoadingGlobe({ className, size = 100 }: LoadingGlobeProps) {
  return (
    <LottieSvg
      src={LOADING_GLOBE_SRC}
      autoplay
      loop
      className={cn('shrink-0', className)}
      style={{ width: size, height: size }}
      role="status"
      aria-label="Memuat"
    />
  )
}

/** Centered globe for in-page data fetches (dashboard, lists). */
export function PageLoader({ className }: { className?: string }) {
  return (
    <div className={cn('flex min-h-[24rem] flex-1 items-center justify-center', className)}>
      <LoadingGlobe />
    </div>
  )
}
